import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  backendErrors: {},
};

export const accountEditingSlice = createSlice({
  name: 'accountEditing',
  initialState,
  reducers: {
    setAccountBackendErrors: (state, action) => {
      state.backendErrors = action.payload;
    },
    clearAccountBackendErrors: (state) => {
      state.backendErrors = {};
    },
  },
});

export const {
  setAccountBackendErrors,
  clearAccountBackendErrors,
} = accountEditingSlice.actions;

export default accountEditingSlice.reducer;